var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-sheet',{staticClass:"pa-4",attrs:{"rounded":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('TableList',{key:_vm.keyList,ref:"tableList",attrs:{"filter":_vm.filter}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }